import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import BookingPage from './pages/BookingPage';
import AdminLogin from './pages/AdminLogin';
import EnhancedAdminDashboard from './pages/EnhancedAdminDashboard';
import PreCallSurvey from './pages/PreCallSurvey';
import SurveyViewPage from './pages/SurveyViewPage';
import AffiliatesPage from './pages/AffiliatesPage';
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/affiliates" element={<AffiliatesPage />} />
          <Route path="/book" element={<BookingPage />} />
          <Route path="/survey" element={<PreCallSurvey />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<EnhancedAdminDashboard />} />
          <Route path="/admin/survey/:appointmentId" element={<SurveyViewPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;